import { Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'pdp-expo-story',
    templateUrl: './expo-story.component.html',
    styleUrls: ['./expo-story.component.scss'],
    imports: [RouterLink]
})
export class ExpoStoryComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
